import { data } from '../../svg/Condition/data';
import { makeIcon } from '../makeIcon';

export const Condition = makeIcon(data, 'condition', 'Condition');

export default Condition;
